"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockUrlTextProperty = exports.infoBlockUrlTextPropertyDefinition = void 0;
exports.infoBlockUrlTextPropertyDefinition = {
    view: { label: 'Link Text' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'info-block-url-text',
};
const isInfoBlockUrlTextProperty = (prop) => {
    return prop.name === exports.infoBlockUrlTextPropertyDefinition.name;
};
exports.isInfoBlockUrlTextProperty = isInfoBlockUrlTextProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay11cmwtdGV4dC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2stdXJsLXRleHQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxrQ0FBa0MsR0FBRztJQUNoRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsV0FBVyxFQUFFO0lBQzVCLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxxQkFBcUI7Q0FDSSxDQUFBO0FBSTFCLE1BQU0sMEJBQTBCLEdBQUcsQ0FBQyxJQUFrQixFQUFvQyxFQUFFO0lBQ2pHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywwQ0FBa0MsQ0FBQyxJQUFJLENBQUE7QUFDOUQsQ0FBQyxDQUFBO0FBRlksUUFBQSwwQkFBMEIsOEJBRXRDIn0=